import React, { useEffect } from "react";
import { Modal, Box, Typography } from "@mui/material";

interface NotificationModalProps {
  isOpen: boolean;
  title?: string;
  message: string;
  onClose: () => void;
  duration?: number;
}

export const NotificationModal: React.FC<NotificationModalProps> = ({
  isOpen,
  title,
  message,
  onClose,
  duration = 3000,
}) => {
  useEffect(() => {
    if (isOpen) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [isOpen, duration, onClose]);

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      disableAutoFocus
      disableEnforceFocus
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          borderRadius: "8px",
          boxShadow: 24,
          p: 4,
          minWidth: 300,
        }}
      >
        {title && (
          <Typography variant="h6" gutterBottom>
            {title}
          </Typography>
        )}
        <Typography variant="body1">{message}</Typography>
      </Box>
    </Modal>
  );
};
